import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/lib/util/colors'


Vue.use(Vuetify)

import ru from 'vuetify/lib/locale/ru'

const opts = {
    icons: {
        iconfont: 'mdi' || 'fa', // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    lang: {
        locales: { ru },
        current: 'ru',
    },
    theme:{
        themes:{
            dark:{},
            light:{
                background: colors.shades.white
            }
        }
    }
}

export default new Vuetify(opts)
